const GreenChecked = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#1FA009" />
      <path
        d="M5.88239 12.1214L11.1854 16.6668L18.3824 8.3335"
        stroke="white"
        strokeWidth="2.23125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default GreenChecked
